import script from "./HeaderNotificationsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotificationsButton.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNotificationsButton.vue?vue&type=style&index=0&id=e5ff954c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ff954c"]])

export default __exports__